var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGanttDowntime02({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.006,
    height: 26.995,
    viewBox: "0 0 14.006 26.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1151",
    "data-name": "Group 1151",
    transform: "translate(0.006 0.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1145",
    "data-name": "Group 1145",
    transform: "translate(-0.007 -0.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M13.991-.005l-14,9.294V9.6l14-9.313Z",
    transform: "translate(0.007 0.007)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M9.6,0l-9.6,6.376V6.69l10.067-6.7",
    transform: "translate(0.007 0.008)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M13.991,3.109l-14,9.294v.316l14-9.313Z",
    transform: "translate(0.007 -0.21)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M13.991,6.224l-14,9.294v.316l14-9.313Z",
    transform: "translate(0.007 -0.427)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M13.991,9.338l-14,9.294v.316l14-9.313Z",
    transform: "translate(0.007 -0.644)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M13.991,12.452l-14,9.294v.316l14-9.313Z",
    transform: "translate(0.007 -0.862)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M13.991,15.566l-14,9.294v.316l14-9.313Z",
    transform: "translate(0.007 -1.079)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M13.991,18.681l-14,9.294v.316l14-9.313Z",
    transform: "translate(0.007 -1.296)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M5.191,0,0,3.447v.316L5.657,0",
    transform: "translate(0.007 0.007)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M4.341,28.506l9.651-6.421v-.3L3.885,28.5",
    transform: "translate(0.007 -1.513)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M8.694,28.717,14,25.19v-.3L8.234,28.719",
    transform: "translate(0.007 -1.729)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M13.053,28.928,14,28.3V28l-1.4.927",
    transform: "translate(0.007 -1.946)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M.815,0-.006.545V.861L1.288,0",
    transform: "translate(0.007 0.007)",
    fill: "#ffbdbd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1146",
    "data-name": "Group 1146",
    transform: "translate(-0.007 -0.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M13.991,28.288l-14-9.294v-.316l14,9.313Z",
    transform: "translate(0.007 -1.296)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M9.6,28.5l-9.6-6.376v-.316l10.067,6.7",
    transform: "translate(0.007 -1.514)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M13.991,25.174l-14-9.294v-.316l14,9.313Z",
    transform: "translate(0.007 -1.079)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M13.991,22.06l-14-9.294V12.45l14,9.313Z",
    transform: "translate(0.007 -0.861)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M13.991,18.945l-14-9.294V9.335l14,9.313Z",
    transform: "translate(0.007 -0.644)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M13.991,15.831l-14-9.294V6.221l14,9.313Z",
    transform: "translate(0.007 -0.427)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M13.991,12.717l-14-9.294V3.107l14,9.313Z",
    transform: "translate(0.007 -0.21)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M13.991,9.6-.006.308V-.008l14,9.313Z",
    transform: "translate(0.007 0.008)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M5.191,28.724,0,25.275v-.316l5.662,3.767",
    transform: "translate(0.007 -1.734)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M4.341-.006l9.651,6.421v.3L3.885,0",
    transform: "translate(0.007 0.008)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M8.694,0,14,3.526v.3L8.234,0",
    transform: "translate(0.007 0.007)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M13.053.006,14,.633v.3L12.6,0",
    transform: "translate(0.007 0.007)",
    fill: "#ffbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M.815,28.94l-.821-.545v-.316l1.294.861",
    transform: "translate(0.007 -1.952)",
    fill: "#ffbdbd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1147",
    "data-name": "Group 1147",
    transform: "translate(0 0.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_119",
    "data-name": "Polygon 119",
    d: "M14,28.653H0L7,24Z",
    transform: "translate(0 -1.681)",
    fill: "#f86a6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_119-2",
    "data-name": "Polygon 119",
    d: "M0,.007H14L7,4.658Z",
    transform: "translate(0 -0.007)",
    fill: "#f86a6a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGanttDowntime02);
export default __webpack_public_path__ + "static/media/gantt_downtime_02.1a2807b72437543941cdf0c61748b793.svg";
export { ForwardRef as ReactComponent };